var $ = require('../internals/export');

var setPrototypeOf = require('../internals/object-set-prototype-of'); // `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof


$({
  target: 'Object',
  stat: true
}, {
  setPrototypeOf: setPrototypeOf
});